export const TIME_FORMAT = 'HH:mm:ss';
export const SHORT_TIME_FORMAT = 'HH:mm';

export const WEEKDAY_AND_TIME_FORMAT = 'dddd HH:mm';
